<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form inline :model="formData" ref="reportManage">

        <!--仓库名称(名称+ID）-->
        <el-select v-model="selectWarehouse" @change="selectWarehouseBtn">
          <el-option label="仓库ID" value="1"></el-option>
          <el-option label="仓库名称" value="2"></el-option>
        </el-select>
        <el-form-item prop="warehouseId" v-if="selectWarehouse == 1" style="margin-left:10px;">
          <el-input v-model="warehouseId" placeholder="请输入仓库ID"></el-input>
        </el-form-item>
        <el-form-item prop="warehouseName" v-if="selectWarehouse == 2" style="margin-left:10px;">
          <el-input v-model="warehouseName" placeholder="请输入仓库名称"></el-input>
        </el-form-item>

        <!--供应商(名称+ID）-->
        <el-select v-model="selectSupplier" @change="selectSupplierBtn">
          <el-option label="供应商ID" value="1"></el-option>
          <el-option label="供应商名称" value="2"></el-option>
        </el-select>
        <el-form-item prop="supplierId" v-if="selectSupplier == 1" style="margin-left:10px;">
          <el-input v-model="supplierId" placeholder="请输入供应商ID"></el-input>
        </el-form-item>
        <el-form-item prop="supplierName" v-if="selectSupplier == 2" style="margin-left:10px;">
          <el-input v-model="supplierName" placeholder="请输入供应商名称"></el-input>
        </el-form-item>

        <!--SKU(名称+ID）-->
        <el-select v-model="selectSku" @change="selectSkuBtn">
          <el-option label="SKU-ID" value="1"></el-option>
          <el-option label="SKU名称" value="2"></el-option>
        </el-select>
        <el-form-item prop="skuId" v-if="selectSku == 1" style="margin-left:10px;">
          <el-input v-model="skuId" placeholder="请输入SKU-ID"></el-input>
        </el-form-item>
        <el-form-item prop="skuName" v-if="selectSku == 2" style="margin-left:10px;">
          <el-input v-model="skuName" placeholder="请输入SKU名称"></el-input>
        </el-form-item>


        <el-form-item label="查询日期">
          <el-date-picker
              v-model="createTime"
              type="daterange"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              style="margin-left:10px;width:500px;"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item style="width:100%">
          <el-button type="success" @click="toExport" size="small">导出报表</el-button>
        </el-form-item>
      </el-form>


      <el-table v-loading="loading" :data="tableData">
        <el-table-column label="客户id" align="center" width="150px" prop="groupId"></el-table-column>
        <el-table-column label="客户名称" align="center" width="150px" prop="groupName"></el-table-column>
        <el-table-column label="客户类型" align="center" width="100px" prop="businessType"></el-table-column>

        <el-table-column label="供应商id" align="center" width="120px" prop="supplierId"></el-table-column>
        <el-table-column label="供应商名称" align="center" width="100px" prop="supplierName"></el-table-column>

        <el-table-column label="仓库id" align="center" width="120px" prop="warehouseId"></el-table-column>
        <el-table-column label="仓库名称" align="center" width="100px" prop="warehouseName"></el-table-column>

        <el-table-column label="批次号" align="center" width="100px" prop="fbatch"></el-table-column>
        <el-table-column label="采购单ID" align="center" width="100px" prop="fwmsReceive"></el-table-column>

        <el-table-column label="一级采销分类" align="center" width="100px" prop="class1Id"></el-table-column>
        <el-table-column label="一级采销分类名称" align="center" width="100px" prop="class1Name"></el-table-column>
        <el-table-column label="商品id" align="center" width="100px" prop="skuId"></el-table-column>
        <el-table-column label="商品名称" align="center" width="100px" prop="skuName"></el-table-column>

        <el-table-column label="在库数量" align="center" width="100px" prop="amountFormat"></el-table-column>
        <el-table-column label="失效日期" align="center" width="100px" prop="expDateStr"></el-table-column>
        <el-table-column label="保质期天数" align="center" width="100px" prop="shelfLifeDays"></el-table-column>
        <el-table-column label="距离失效剩余天数" align="center" width="100px" prop="diffExpDay"></el-table-column>
        <el-table-column label="失效期预警天数" align="center" width="100px" prop="expDateAlarm"></el-table-column>
        <el-table-column label="在库天数" align="center" width="100px" prop="stockDay"></el-table-column>
        <el-table-column label="生产日期" align="center" width="100px" prop="productionDateStr"></el-table-column>
        <el-table-column label="在库金额（参考值）" align="center" width="100px" prop="stockPrice"></el-table-column>
        <el-table-column label="日期" align="center" width="100px" prop="dt"></el-table-column>
      </el-table>
      <div class="footer pager">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="formData.pageNumber"
            :page-size.sync="formData.pageSize"
            :page-sizes="[20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total.sync="total"
            background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>

import {getBaseUrl, param} from "@/framework/utils/tools";

export default {
  data() {
    return {
      selectWarehouse: '1',
      warehouseId: "",
      warehouseName: "",

      selectSupplier: '1',
      supplierId: "",
      supplierName: "",

      selectSku: '1',
      skuId: "",
      skuName: "",

      createTime: [],

      formData: {
        warehouseId: "",
        warehouseName: "",
        supplierId: "",
        supplierName: "",
        skuId: "",
        skuName: "",
        startTime: "",
        endTime: "",
        pageNumber: 1,
        pageSize: 20,
        fromSource: "cs"
      },
      total: 0,
      loading: false,
      tableData: [],
      pickerOptions: {
        disabledDate(time) {
          let cur_time = new Date(new Date().toLocaleDateString()).getTime();
          return time.getTime() > cur_time + 86400000 - 1000 || time.getTime() < (Date.now() - 3600 * 1000 * 24 * 30);
        }
      }
    };
  },

  watch: {
    "createTime": {
      handler: function (val) {
        if (val) {
          const [start_time, end_time] = val;
          Object.assign(this.formData, {startTime: start_time / 1000, endTime: end_time / 1000});
        } else {
          Object.assign(this.formData, {startTime: "", endTime: ""});
        }
      }
    },
    "warehouseId": {
      handler: function (val) {
        this.formData.warehouseId = val
      }
    },
    "warehouseName": {
      handler: function (val) {
        this.formData.warehouseName = val
      }
    },
    "supplierId": {
      handler: function (val) {
        this.formData.supplierId = val
      }
    },
    "supplierName": {
      handler: function (val) {
        this.formData.supplierName = val
      }
    },
    "skuId": {
      handler: function (val) {
        this.formData.skuId = val
      }
    },
    "skuName": {
      handler: function (val) {
        this.formData.skuName = val
      }
    }
  },
  methods: {
    selectWarehouseBtn(val) {
      this.warehouseId = "";
      this.warehouseName = "";
      this.formData.warehouseId = '';
      this.formData.warehouseName = '';
    },
    selectSupplierBtn(val) {
      this.supplierId = "";
      this.supplierName = "";
      this.formData.supplierId = '';
      this.formData.supplierName = '';
    },
    selectSku(val) {
      this.skuId = "";
      this.skuName = "";
      this.formData.skuId = '';
      this.formData.skuName = '';
    },
    // 重置
    reset() {
      this.selectWarehouse = '1';
      this.warehouseId = "";
      this.warehouseName = "";

      this.selectSupplier = '1';
      this.supplierId = "";
      this.supplierName = "";

      this.selectSku = '1';
      this.skuId = "";
      this.skuName = "";

      this.formData.warehouseId = "";
      this.formData.warehouseName = "";
      this.formData.supplierId = "";
      this.formData.supplierName = "";
      this.formData.skuId = "";
      this.formData.skuName = "";
      if (this.$refs["cusOption"]) {
        this.$refs["cusOption"].reset()
      }
      this.$refs["reportManage"].resetFields();
      this.createTime = []
    },
    search() {
      if (!this.formData.startTime || !this.formData.endTime) {
        this.$message({
          type: "warning",
          message: "请选择日期范围"
        });
        return;
      }
      this.formData.pageNumber = 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const {
        ret,
        data: {list, totalCount}
      } = await _api.report.skuStockPage(this.formData);
      if (ret && list) {
        this.tableData = list || [];
        this.total = totalCount;
      }
      this.loading = false;
    },

    handleCurrentChange(val) {
      this.getList();
    },
    handleSizeChange(val) {
      this.formData.pageNumber = 1;
      this.getList();
    },
    //导出
    /*async exportFile() {
      this.loading = true;
      const {
        ret,
        data
      } = await _api.report.skuStockDownload(this.formData);

      this.loading = false;
    },*/
    async toExport() {
      this.loading=true;
      const {ret, data} = await _api.report.skuStockDownload(this.formData);
      this.loading=false;

      if(ret){
        var a = document.createElement('a');
        a.setAttribute('href', data);
        document.body.appendChild(a);
        a.click();
      }
    }
  }
};
</script>
<style>
.img li {
  float: left;
  margin-left: 5px;
  list-style-type: none;
}
</style>